import api from '@/api'

export type MailboxSizeInfo = {
  personCode: string
  totalSizeBytes: number
  sizeLimitBytes: number
}

export default {
  getMailboxSizeInfo() {
    return api.get<MailboxSizeInfo>({
      url: '/api/mail/mailbox/size',
    })
  },
}
